import JsBarcode from "jsbarcode";
import moment from "moment";
import CompanyLogoForm from "react-lib/apps/HISV3/common/CompanyLogoForm";

// Common
import { getLogoReportNResize } from "../common/CommonInterface";

import CONFIG from "config/config";

const LOGO_HEIGHT_MAP: Record<any, number> = {
  RAMASRI: 40,
};

const textToBase64BarcodeBlob = (text: string) => {
  const canvas = document.createElement("canvas");
  JsBarcode(canvas, text, { displayValue: false });
  return canvas.toDataURL("image/png");
};

export const createPDFLabOrderQueue = async (props: any) => {
  console.log("createPDFLabRequest props", props);

  const logoHeight = LOGO_HEIGHT_MAP[CONFIG.COMPANY] ?? 30;

  const companyLogoForm = await CompanyLogoForm({
    font: "THSarabunNew",
    height: logoHeight,
    form: "FormLabRequest",
  });
  const { images } = companyLogoForm;

  const logo = await getLogoReportNResize(logoHeight, 1, "FormLabRequest");

  import("pdfmake/build/pdfmake").then((make) => {
    import("react-lib/assets/fonts/pdfFonts").then(async (font) => {
      let pdfMake = make.default;
      pdfMake.vfs = font.default;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew-Bold.ttf",
          italics: "THSarabunNew-Italic.ttf",
          bolditalics: "THSarabunNew-BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      const truncateTextBasedWidth = (text: string, maxWidth: number, charWidth: number) => {
        let maxChars = Math.floor(maxWidth / charWidth);

        if (text.length > maxChars) {
          return text.substring(0, maxChars - 3) + "...";
        }

        return text;
      };

      let today = new Date();
      let getdate =
        today.getDate() + "/" + (today.getMonth() + 1) + "/" + (today.getFullYear() + 543);

      let gettime = today.getHours() + ":" + today.getMinutes();
      let time = moment(gettime, "hh:mm").format("HH:mm");
      let timenow = `${time}`;
      let id = props?.data?.full_access_number;

      let hn = props?.data?.hn;
      let hn_s = `${hn}`;
      let patient_name = props?.data?.patient_name;
      let patient_name_s = `${patient_name}`;
      let datetime = props?.data?.date;
      let datetime_s = `${datetime}`;
      let doctor_name = props?.data?.doctor_name;
      let doctor_name_s = `${doctor_name}`;
      let division_name = props?.data?.division_name;
      let division_name_s = `${division_name}`;
      let highest_urgency = props?.data?.highest_urgency;
      let highest_urgency_s = `${highest_urgency}`;

      let birthdate = props?.hn_data?.birthdate || "";
      let birthdate_s = `${birthdate}`;
      let full_age = props?.hn_data?.full_age || "";
      let full_age_s = `${full_age}`;
      let coverage = props?.hn_data?.coverage || "";
      let coverage_s = truncateTextBasedWidth(`${coverage}`, 250, 6.5);
      let gender_name = props?.hn_data?.gender_name;
      let gender_name_s = `${gender_name}`;

      let urgency = props?.urgency;
      let username = props?.username;

      function printUrgency(highest_urgency: any) {
        if (highest_urgency === "STAT") {
          return {
            text: "STAT",
            style: "fieldHead",
            color: "red",
          };
        } else if (highest_urgency === "FAST_STACK") {
          return {
            text: "FAST_STACK",
            style: "fieldHead",
            color: "red",
          };
        } else {
          return { text: " " };
        }
      }

      let labOrderList = props?.lab_data?.specimen_containers?.map((item: any) => {
        let specimen_name = item?.specimen_name;
        let specimen_name_s = `${specimen_name}`;
        let lab_code = item?.lab_code;
        let lab_test = item?.all_lab_test;

        function printLabcode(lab_code: any) {
          let input = lab_code?.split(",");
          var labOutput = "";
          for (let i = 0; i < input.length; i++) {
            labOutput += input[i] + "\n";
          }

          return labOutput;
        }
        function printLabtest(lab_test: any) {
          let input = lab_test?.split("-");
          console.log(input);
          return input;
        }

        return [
          { text: specimen_name_s, style: "fieldValues" },
          { text: printLabcode(lab_code), style: "fieldValues" },
          { text: printLabtest(lab_test), style: "fieldValues" },
        ];
      });

      // BLOOD_COMPONENT = 105, "Blood Component"
      const isBloodComponent = props?.data?.lab_speciality === 105;

      var docDefinition = await {
        defaultStyle: {
          font: "THSarabunNew",
        },
        pageMargins: [8, 147, 0, 90],
        pageSize: "A5",
        pageOrientation: "landscape",
        styles: {
          fieldHead: {
            bold: true,
            fontSize: 18,
          },
          fieldIDHead: {
            bold: true,
            fontSize: 16,
          },
          fieldOPHead: {
            bold: true,
            fontSize: 18,
          },
          fieldDataBold: {
            bold: true,
            fontSize: 14,
          },
          fieldValues: {
            fontSize: 14,
          },
          fieldFooter: {
            fontSize: 12,
          },
          tableHeader: {
            fillColor: "white",
          },
          tableNormal: {
            margin: [0, 5, 0, 5],
          },

          tableExample: {
            margin: [0, 0, 0, 0],
          },
        },
        header: {
          // margin: [0, 8, 30, 0],

          stack: [
            // Table Layout
            {
              columns: [
                {
                  table: {
                    widths: [552],
                    // heights: [55, 245], // 305
                    heights: [55],
                    body: [[{ text: " " }]],
                  },
                },
              ],
              relativePosition: { x: 17, y: 57 },
            },
            {
              table: {
                widths: [552],
                heights: 100,
                body: [[{ text: " ", border: [true, false, true, false] }]],
              },
              relativePosition: { x: 17, y: 117 },
            },
            {
              table: {
                widths: [552],
                heights: 100,
                body: [[{ text: " ", border: [true, false, true, false] }]],
              },
              relativePosition: { x: 17, y: 217 },
            },
            {
              table: {
                widths: [552],
                heights: 47,
                body: [[{ text: " ", border: [true, false, true, true] }]],
              },
              relativePosition: { x: 17, y: 317 },
            },
            {
              columns: [
                !CONFIG.HIDE_COMPANY_LOGO_PRINT
                  ? {
                      image: "logo",
                      height: logoHeight,
                      width: logo.width,
                      absolutePosition: { x: 14, y: 10 },
                    }
                  : null,
                {
                  text: `${props?.lab_type}: ${id}`,
                  style: "fieldIDHead",
                  absolutePosition: { x: 475, y: 8 },
                },
              ],
            },

            {
              columns: [
                {
                  text: [
                    {
                      text: isBloodComponent ? "ใบจองเลือด" : "ใบขอตรวจแลป (Lab Request)",
                      style: "fieldHead",
                      alignment: "center",
                    },
                  ],
                  relativePosition: { x: 0, y: 26.5 },
                },
              ],
            },
            {
              columns: [
                {
                  text: printUrgency(highest_urgency),
                },
              ],
              relativePosition:
                highest_urgency === "FAST_STACK" ? { x: 508, y: 26.5 } : { x: 550, y: 26.5 },
            },
            {
              columns: [
                {
                  margin: [10, 0, 0, 0],
                  width: 180,
                  text: [
                    { text: "HN : ", style: "fieldDataBold" },
                    { text: hn_s, style: "fieldValues" },
                  ],
                },
                {
                  width: 320,
                  text: [
                    { text: "ชื่อ - สกุล : ", style: "fieldDataBold" },
                    { text: patient_name_s, style: "fieldValues" },
                  ],
                },
                {
                  width: 52,
                  text: [
                    { text: "เพศ : ", style: "fieldDataBold" },
                    {
                      ...(gender_name_s === "Female"
                        ? {
                            text: "หญิง",
                          }
                        : {
                            text: "ชาย",
                          }),
                      style: "fieldValues",
                    },
                  ],
                  alignment: "right",
                },
              ],
              relativePosition: { x: 17, y: 72 },
            },
            {
              columns: [
                {
                  margin: [10, 0, 0, 0],
                  width: 180,
                  text: [
                    { text: "วันเดือนปีเกิด : ", style: "fieldDataBold" },
                    { text: birthdate_s, style: "fieldValues" },
                  ],
                },
                {
                  width: 140,
                  text: [
                    { text: "อายุ : ", style: "fieldDataBold" },
                    { text: full_age_s, style: "fieldValues" },
                  ],
                },
                {
                  width: 232,
                  text: [
                    {
                      text: "สิทธิการรักษา : ",
                      style: "fieldDataBold",
                    },
                    { text: coverage_s, style: "fieldValues" },
                  ],
                  alignment: "right",
                },
              ],
              relativePosition: { x: 17, y: 92 },
            },
            {
              columns: [
                {
                  margin: [10, 0, 0, 0],
                  width: 210,
                  text: [
                    { text: "วัน เวลา ที่สั่ง : ", style: "fieldDataBold" },
                    { text: datetime_s, style: "fieldValues" },
                  ],
                },
                {
                  width: 342,
                  text: [
                    { text: "แพทย์ผู้สั่ง : ", style: "fieldDataBold" },
                    { text: doctor_name_s, style: "fieldValues" },
                    { text: " (", style: "fieldValues" },
                    { text: division_name_s, style: "fieldValues" },
                    { text: ") ", style: "fieldValues" },
                  ],
                  alignment: "right",
                },
              ],
              relativePosition: { x: 17, y: 127 },
            },
            {
              columns: [
                {
                  margin: [10, 0, 0, 0],
                  text: `Remark : ${props.data.note || "-"}`,
                  fontSize: 14,
                },
              ],
              relativePosition: { x: 17, y: 346.5 },
            },
            {
              margin: [0, 0, 70, 0],
              columns: [
                {
                  image: textToBase64BarcodeBlob(id),
                  width: 80,
                  height: 35,
                  alignment: "right",
                },
              ],
              relativePosition: { x: 494, y: 330 },
            },
          ],
        },

        images: {
          ...images,
        },
        content: [
          {
            margin: [0, 0, 0, 100],
            style: "tableExample",
            absolutePosition: { x: 27, y: 147 },
            table: {
              headerRows: 1,
              widths: ["23.5%", "20%", "52%"],
              body: [
                [
                  { text: "Specimen", style: "fieldDataBold" },
                  { text: "Code", style: "fieldDataBold" },
                  { text: "Lab test", style: "fieldDataBold" },
                ],

                ...labOrderList,
              ],
            },
            layout: {
              hLineWidth(i: number, node: any) {
                if (i === node.table.body.length) {
                  return 0;
                }
                return i === 0 || i === node.table.headerRows ? 2 : 1;
              },
              vLineWidth(i: number) {
                return 0;
              },
              hLineColor(i: number) {
                return i === 0 || i === 1 ? "black" : "#aaa";
              },
              paddingLeft(i: number) {
                return i === 0 ? 0 : 8;
              },
              paddingRight(i: number, node: any) {
                return i === node.table.widths.length - 1 ? 0 : 8;
              },
            },
          },
        ],
        footer: function (currentPage: any, pageCount: any) {
          return {
            margin: [17, 68, 0, 0],
            text: [
              {
                text: [{ text: " ผู้พิมพ์ : ", style: "fieldDataBold" }],
                alignment: "right",
              },
            ],

            columns: [
              {
                width: 230,
                text: [
                  {
                    text: [
                      { text: " ผู้พิมพ์ : ", style: "fieldFooter" },
                      { text: username, style: "fieldFooter" },
                    ],
                    alignment: "right",
                  },
                ],
              },

              {
                width: 295,
                text: [
                  {
                    text: [
                      { text: " วัน เวลาที่พิมพ์:", style: "fieldFooter" },
                      { text: ` ${getdate} `, style: "fieldFooter" },
                      { text: "[", style: "fieldFooter" },
                      { text: `${timenow}`, style: "fieldFooter" },
                      { text: "]", style: "fieldFooter" },
                    ],
                    alignment: "right",
                  },
                ],
              },
              {
                text: [
                  {
                    text: [
                      {
                        text: " หน้าที่ " + currentPage.toString() + "/" + pageCount,
                        style: "fieldPrintDate",
                      },
                    ],
                    alignment: "left",
                  },
                ],
              },
            ],
          };
        },
      };

      let pdfDocGenerator = pdfMake.createPdf(docDefinition).open();
    });
  });
};
